export enum HeaderConfig {
    PositionL = 'positionL',
    PositionM = 'positionM'
}
